import script from "./icon-location.vue?vue&type=script&lang=ts&setup=true"
export * from "./icon-location.vue?vue&type=script&lang=ts&setup=true"

import "./icon-location.vue?vue&type=style&index=0&id=4f5daf1d&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f5daf1d"]])

export default __exports__